import { render } from "./Potention.vue?vue&type=template&id=6b361fce&scoped=true"
import script from "./Potention.vue?vue&type=script&lang=js"
export * from "./Potention.vue?vue&type=script&lang=js"

import "./Potention.vue?vue&type=style&index=0&id=6b361fce&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b361fce"]])

export default __exports__